var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconGoogleDrive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10450_35802)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.20962 13.2513L1.91523 14.4701C2.06186 14.7266 2.27262 14.9282 2.52005 15.0749L5.04009 10.7129H0C0 10.997 0.0733104 11.281 0.219931 11.5376L1.20962 13.2513Z",
    fill: "#0066DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 5.58267L5.47995 1.2207C5.23253 1.36732 5.02176 1.56893 4.87514 1.82551L0.219931 9.88966C0.076007 10.1407 0.000191627 10.425 0 10.7144H5.04009L8 5.58267Z",
    fill: "#00AC47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4804 15.0749C13.7278 14.9282 13.9386 14.7266 14.0852 14.4701L14.3784 13.966L15.7805 11.5376C15.9271 11.281 16.0004 10.997 16.0004 10.7129H10.96L12.0325 12.8206L13.4804 15.0749Z",
    fill: "#EA4335"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.99954 5.5819L10.5196 1.21993C10.2722 1.07331 9.98808 1 9.69484 1H6.30423C6.01099 1 5.72691 1.08247 5.47949 1.21993L7.99954 5.5819Z",
    fill: "#00832D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9604 10.7129H5.04055L2.52051 15.0749C2.76793 15.2215 3.05201 15.2948 3.34525 15.2948H12.6557C12.9489 15.2948 13.233 15.2123 13.4804 15.0749L10.9604 10.7129Z",
    fill: "#2684FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4525 5.85759L11.1249 1.82551C10.9782 1.56893 10.7675 1.36732 10.52 1.2207L8 5.58267L10.9599 10.7144H15.9908C15.9908 10.4303 15.9175 10.1462 15.7709 9.88966L13.4525 5.85759Z",
    fill: "#FFBA00"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10450_35802"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGoogleDrive);
export default __webpack_public_path__ + "static/media/icon-google-drive.6d308bd5e67c891c88b8f1465dc15619.svg";
export { ForwardRef as ReactComponent };